export default {
  name: "BasicLayout"
};